function initialize(): void {
  const reviewsWrapper: HTMLElement | null = document.body.querySelector('.reviews__wrapper')

  if (reviewsWrapper !== null) {
    reviewsWrapper.addEventListener('click', (event: MouseEvent) => {
      const target = event.target as HTMLElement
      const button = target.closest('.comment__button')

      if (button !== null) {
        const comment = button.closest('.review__comment')

        if (comment !== null) {
          // Decode the source comment the first time before making it visible.
          const sourceElement: HTMLElement | null = comment.querySelector('[data-comment-source]')
          if (sourceElement !== null) {
            const encodedComment = sourceElement.dataset.commentSource as string
            const decodedComment = decodeURIComponent(atob(encodedComment))
            sourceElement.innerHTML = decodedComment
            delete sourceElement.dataset.commentSource
          }

          comment.classList.toggle('comment__source')
        }
      }
    })
  }
}

export default (): void => {
  initialize()
}
